import { gatewayApi } from './api';

export const financialsService = {
  async listDeposits(params = {}) {
    const { data } = await gatewayApi.get('/v1/financials/deposits', { params });
    return data;
  },
  async listWithdrawals(params = {}) {
    const { data } = await gatewayApi.get('/v1/financials/withdrawals', { params });
    return data;
  },
  async getDeposit(id) {
    const { data } = await gatewayApi.get(`/v1/financials/deposits/${id}`);
    return data;
  },
  async getWithdrawal(id) {
    const { data } = await gatewayApi.get(`/v1/financials/withdrawals/${id}`);
    return data;
  },
  async createDeposit(payload) {
    const idempotencyKey = window.crypto?.randomUUID?.() || `dep-${Date.now()}`;
    const { data } = await gatewayApi.post('/v1/financials/deposits', payload, {
      headers: { 'idempotency-key': idempotencyKey },
    });
    return data;
  },
  async createWithdrawal(payload) {
    const idempotencyKey = window.crypto?.randomUUID?.() || `wth-${Date.now()}`;
    const { data } = await gatewayApi.post('/v1/financials/withdrawals', payload, {
      headers: { 'idempotency-key': idempotencyKey },
    });
    return data;
  },
  async cancelDeposit(id) {
    const { data } = await gatewayApi.post(`/v1/financials/deposits/${id}/cancel`);
    return data;
  },
  async cancelWithdrawal(id) {
    const { data } = await gatewayApi.post(`/v1/financials/withdrawals/${id}/cancel`);
    return data;
  },
};
